import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import {
  EntityMonitoringTypeKey,
  MonitoringConnectionCompositeEntity,
  ScreeningEntityScreeningCaseStateEntity,
} from '@nk/data-entities-lib';

export const DEFAULT_COMPANY_ROLES_PAGE_LIMIT = 1000;

export const ENTITY_MONITORING_TYPE_TRANSLATIONS: Record<EntityMonitoringTypeKey, string> = {
  [EntityMonitoringTypeKey.beneficial_owners]: extractTranslation('screening.monitoring_type.types.beneficial_owner'),
  [EntityMonitoringTypeKey.alternative_beneficial_owners]: extractTranslation(
    'screening.monitoring_type.types.alternative_beneficial_owner',
  ),
  [EntityMonitoringTypeKey.company]: extractTranslation('screening.monitoring_type.types.company'),
  [EntityMonitoringTypeKey.other]: extractTranslation('screening.monitoring_type.types.other'),
  [EntityMonitoringTypeKey.extended_beneficial_owners]: extractTranslation(
    'screening.monitoring_type.types.extended_beneficial_owners',
  ),
  [EntityMonitoringTypeKey.extended_alternative_beneficial_owners]: extractTranslation(
    'screening.monitoring_type.types.extended_alternative_beneficial_owners',
  ),
};

export enum ScreeningColumnProps {
  HoursAgo = 'hoursAgo',
  CreatedTimestamp = 'data.screening_case.created_timestamp',
  EntityName = 'entityName',
  RelatedCompanies = 'data.related_companies',
  EntityAssigneeAppMembershipUuid = 'entityAssigneeAppMembershipUuid',
  EntityReviewStatus = 'entityReviewStatus',
}

export const DEFAULT_MONITORING_ADD_DECISION_COMMENT = 'Auto approved (Entry added by user)';
export const DEFAULT_MONITORING_REMOVE_DECISION_COMMENT = 'Auto approved (Entry removed by user)';

export type ScreeningCardListDetailsInputData = {
  uuid: string;
  type: 'person' | 'customer_person';
  monitoring_origin_entity_company_uuid: string | null;
  person_master_uuid: string | null;
  birth_date: Date | null;
  birth_year: number | null;
  national_identification_schema: string | null;
  street_address: string | null;
  postal_code: string | null;
  postal_place: string | null;
  municipality_name: string | null;
  country_name: string | null;
};

export type ScreeningCaseReviewInputData = Omit<ScreeningCardListDetailsInputData, 'type'> & {
  type: 'person' | 'customer_person' | 'company';
  full_name: string;
  monitoring_origin_entity_company_uuid: string | null;
  monitoring_origin_entity_company_name: string | null;
  pep_flag: boolean;
  sanction_flag: boolean;
  screening_entity_screening_case_state: ScreeningEntityScreeningCaseStateEntity;
};

interface AddToScreeningBaseProps {
  screeningConfigUuid: string;
  monitoringOriginEntityUuid: string;
  appMembershipUuid: string;
  entityMonitoringTypeUuid: string;
}

export type AddToScreeningPersonProps = AddToScreeningBaseProps & {
  personUuid: string;
};

export type AddToScreeningCustomerPersonProps = AddToScreeningBaseProps & {
  customerPersonUuid: string;
};

export type AddToScreeningModalProps = { title: string } & (
  | AddToScreeningPersonProps
  | AddToScreeningCustomerPersonProps
);

export type ScreeningCommentFormValue = {
  comment: string | null;
};

export interface ScreeningRemovePersonParams {
  screeningConfigUuid: string;
  appMembershipUuid: string;
  monitoringOriginEntityUuid: string;
  screeningEntityUuid: string;
  entityMonitoringTypeUuid: string;
}

export function isScreeningRemovePersonParams(item: unknown): item is ScreeningRemovePersonParams {
  return (
    typeof item === 'object' &&
    item !== null &&
    item.hasOwnProperty('screeningConfigUuid') &&
    item.hasOwnProperty('appMembershipUuid') &&
    item.hasOwnProperty('entityMonitoringTypeUuid') &&
    item.hasOwnProperty('monitoringOriginEntityUuid') &&
    item.hasOwnProperty('screeningEntityUuid') &&
    (!!(item as Record<string, unknown>)['person'] || !!(item as Record<string, unknown>)['customerPerson'])
  );
}

export function getCurrentlyScreeningDict(
  monitoringConnectionComposites: MonitoringConnectionCompositeEntity[] = [],
): Record<string, true> {
  return monitoringConnectionComposites.reduce((acc: Record<string, true>, entity) => {
    if (entity.person?.uuid) {
      acc[entity.person?.uuid] = true;
    }
    if (entity.company?.uuid) {
      acc[entity.company?.uuid] = true;
    }
    if (entity.customer_person?.uuid) {
      acc[entity.customer_person?.uuid] = true;
    }
    return acc;
  }, {});
}
